import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  ocSearchPanel: {
    display: "flex",
    alignItems: "center",
  },
  headerColor: {
    color: "#FFFFFF",
  },
  ocInputField: {
    '& .MuiOutlinedInput-root': {
      flex: 1,
      paddingRight: 0,
      backgroundColor: "#FFFFFF",
      '& fieldset': {
        borderRadius: 0,
        border: "1px solid #CCCCCC",
        minHeight: "39px",
      },
    },
    marginRight: 10,
  },
  modalOCHeader: {
    padding: 10,
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalOCBody: {
    padding: 10,
  },
  modalOCWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    width: "100vw",
    height: "100vh",
  },
  modalOCContainer: {
    border: "2px solid #000",
    backgroundColor: "#FFF",
    width: "100%",
    maxWidth: "800px",
    maxHeight: "100vh",
    overflow: "auto",
  },
  modaFooter: {
    backgroundColor: "#CCCCCC",
    padding: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  searchIcon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  placeholder: {
    marginTop: 2,
    marginLeft: 10,
  },
  smButton: {
    background: "#658D1B",
    border: 0,
    borderRadius: 1,
    color: "white",
    marginLeft: 3,
    width: 220,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
    height: 38,
  },
  smButtonModal: {
    border: 0,
    borderRadius: 1,
    color: "white",
    marginLeft: 3,
    width: 120,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    height: 38,
    '&.clear': {
      background: '#d57f00',
      color: 'white',
    }
  },
  ocBoxLabel: {
    marginLeft: 10,
  },
  ocBox: {
    display: "flex",
    marginRight: 10,
    marginLeft: 10,
    minWidth: 350,
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  reasonField: {
    width: '90%',
    margin: '0 auto',
    backgroundColor: 'white',
  }
}));

export default useStyles;
